import IconButton from '@mui/material/IconButton';

import { faFacebookSquare, faInstagram, faLinkedin, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LINKS_CONFIG = [
  {
    key: 'instagram',
    icon: faInstagram,
    url: 'https://www.instagram.com/wizeprep/',
  },
  {
    key: 'youtube',
    icon: faYoutube,
    url: 'https://www.youtube.com/channel/UC_PXdjw6d2o1KcTMUtcDgoQ',
  },
  {
    key: 'facebook',
    icon: faFacebookSquare,
    url: 'https://www.facebook.com/wizeprep',
  },
  {
    key: 'linkedin',
    icon: faLinkedin,
    url: 'https://www.linkedin.com/company/25070493/',
  },
  { key: 'tiktok', icon: faTiktok, url: 'https://www.tiktok.com/@wizeprep' },
];
export default function SocialMediaButtons(props) {
  const { ButtonProps, IconProps } = props;

  return LINKS_CONFIG.map(({ icon, key, url }) => (
    <IconButton
      key={key}
      component="a"
      href={url}
      name={key}
      nativeButton={false}
      rel="noreferrer"
      sx={{ width: 30, height: 30, '& + &': { ml: 1 } }}
      target="_blank"
      {...ButtonProps}
      className={ButtonProps?.className}
    >
      <FontAwesomeIcon icon={icon} size="xs" {...IconProps} />
    </IconButton>
  ));
}
